import { RootState } from 'editor/src/store/index';

const getShowValueFormatErrors = (state: RootState) => state.editor.showValueFormatErrors;

export default getShowValueFormatErrors;
